<template>
  <div>
    <header1 title="医博士网服务协议"></header1>
    <div style="width:1002px; margin:0 auto; background: #fff;padding: 0px 20px;">
      <div class="use_xieyi" style="color:#666;">
        <div class="use_xieyi_title">《医博士网服务协议》</div>
        <div class="use_xieyi_main"> <strong style="font-size:16px;">1.您与医博士网的关系</strong><br>
          1.1 您对医博士网产品、软件、服务及网站（本文件中合称"服务"，不包括在单独的书面协议项下医博士网向您提供的任何服务）的使用适用您和医博士网之间法律协议的条款。"医博士网"指北京亿和博嘉教育科技有限公司，主营业地位于北京海淀区中关村东路财智大厦A座1901室。本文件解释了协议如何制定，并陈述了协议中的若干条款。<br>
          1.2 除非与医博士网另有书面协议，否则您与医博士网的协议将始终至少包括本文件中陈述的条款和条件。这些条款和条件下称"通用条款"。<br>
          1.3 除通用条款外，您与医博士网的协议亦将包括适用于服务的任何法律声明中的条款。所有这些法律声明中的条款下称"额外条款"。额外条款适用于服务时，您可在该服务范围内或使用该服务过程中读到该等条款。<br>
          1.4 通用条款，连同额外条款，构成您和医博士网之间关于您使用服务的具有法律约束力的协议。您花时间仔细加以阅读是重要的。该法律协议以下合称"本条款"。<br>
          1.5 如果额外条款的内容和通用条款的内容发生任何冲突，则就该服务内容，应以额外条款为准。<br>
          <strong style="font-size:16px;">2.接受本条款</strong><br>
          2.1 使用服务必须首先同意本条款。如果您不接受本条款则不可使用服务。<br>
          2.2 您可通过下列方式接受本条款：<br>
          (A)在有关任何服务的用户界面上医博士网向您提供的选择处点击以接受或同意本条款；或<br>
          (B)实际使用服务。在此情况下，您理解并同意医博士网视您自使用服务时起接受本条款。<br>
          2.3 在下列情况下您不可使用服务且不能接受本条款：(a)您未达到与医博士网订立有约束力的合同的法定年龄，或(b)根据中国或其他国家（包括您居住的或您从那里使用服务的国家）的法律，您是被禁止接受服务的人。<br>
          <strong style="font-size:16px;">3.本条款语言</strong><br>
          3.1 医博士网向您提供本条款中文文本的翻译件时，您同意翻译件仅供您方便之用，本条款的中文文本适用于您和医博士网之间的关系。<br>
          3.2 如果本条款中文文本和翻译文本存在任何冲突，则以中文文本为准。<br>
          <strong style="font-size:16px;">4.医博士网提供服务</strong><br>
          4.1 医博士网在世界范围内拥有子公司和关联法律实体（"子公司和关联公司"）。在某些时候，这些公司将代表医博士网向您提供服务。您认知并同意子公司和关联公司有权向您提供服务。<br>
          4.2 医博士网不断创新以向其用户提供最优体验。您认知并同意医博士网提供的服务的形式和本质可不经事先通知您而不时变换。<br>
          4.3 作为这种持续创新的一部分，您认知并同意医博士网自行决定，无须事先通知您，即停止（永久或暂时）向您或全体用户提供服务。您可在任何时候停止使用服务。您停止使用服务时无需特别通知医博士网。<br>
          4.4 您认知并同意，如果医博士网禁用对您的帐户的访问权，则您可能被阻止获得服务、您的帐户资料或包含在您帐户中的任何文件或其他内容。<br>
          4.5 如果您得知任何对您的密码或您的帐户的任何未经授权的使用，您同意立即通知医博士网。 </div>
        <div class="user_xieyi_close"><a href="javascript:;" onclick="window.close();">关   闭</a></div>
      </div>
    </div>
    <div style="width:1002px;margin: 0 auto;"><footer1></footer1></div>
  </div>
</template>

<script>
  import  header1 from '../components/Header1'
  import  footer1 from '../components/Footer1'
  export default {
    components: {
      header1,
      footer1
    },
    data () {
      return {}
    },
    mounted () {
    },
    computed: {},
    methods: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .use_xieyi {
    padding-bottom: 20px;
  }
  .use_xieyi_title {
    text-align: center;
    line-height: 70px;
    font-size: 24px;
  }
  .use_xieyi_main {
    text-align: left;
    line-height: 30px;
    font-size: 14px;
  }
  .user_xieyi_close {
    padding-top: 30px;
  }
  .user_xieyi_close a {
    width: 200px;
    height: 42px;
    color: #fff;
    font-size: 14px;
    background: #2dbcd7;
    text-align: center;
    line-height:42px;
    display: block;
    margin: 0px auto;
    border-radius: 8px;
  }
  .user_xieyi_close a:hover{background: #57c9df;}
</style>



// WEBPACK FOOTER //
// src/views/Contract.vue